"use strict";

document.addEventListener("DOMContentLoaded", function () {
  const searchTrigger = document.getElementById("search-open-button");
  const searchForm = document.getElementById("search-form-container");
  const closeButton = document.getElementById("search-close-button");
  const topBarRight = document.getElementById("top-right");

  const toggleSearch = (escClose = false) => {
    if (escClose) {
      searchForm.classList.remove("header-top__search-form-container--visible");
      topBarRight.classList.remove("header-top__right--hidden");
      searchTrigger.classList.remove("header-top__search--hidden");
    } else {
      const isVisible = searchForm.classList.toggle(
        "header-top__search-form-container--visible",
      );

      searchTrigger.classList.add("header-top__search--hidden");
      topBarRight.classList.toggle("header-top__right--hidden", isVisible);
    }
  };

  searchTrigger.addEventListener("click", function (event) {
    toggleSearch();
  });

  closeButton.addEventListener("click", function (event) {
    toggleSearch(true);
  });

  document.addEventListener("keydown", function (event) {
    if (
      event.key === "Escape" &&
      searchForm.classList.contains(
        "header-top__search-form-container--visible",
      )
    ) {
      toggleSearch(true);
    }
  });
});
